import axios from '@/utils/api'

const actions = {
  async getFotosByCaminhoId ({ commit }, { id, caminho }) {
    const response = await axios({
      method: 'POST',
      url: 'foto/getFotosByCaminhoId',
      data: { id, caminho },
      responseType: 'arraybuffer'
    })
    return response
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/fotos.js